import React, { useState } from 'react';
import PortfolioGrid from '../../Portfolio/PortfolioGrid';
import PortfolioTable from '../../Portfolio/PortfolioTable';

const AttachedPortfoliosSection = ({
	portfolios,
	isLoading,
	error,
	onPortfolioView,
	onPortfolioEdit,
	onPortfolioDelete,
}) => {
	const [viewMode, setViewMode] = useState('grid');

	if (isLoading) {
		return (
			<div className="property-section-card">
				<div className="property-section-body">
					<div className="loading-state">
						<div className="spinner-border" role="status">
							<span className="visually-hidden">Loading portfolios...</span>
						</div>
					</div>
				</div>
			</div>
		);
	}

	if (error) {
		return (
			<div className="property-section-card">
				<div className="property-section-body">
					<div className="error-state">
						<div className="alert alert-danger">
							Error loading portfolios: {error.message || error}
						</div>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="property-section-card">
			<div className="property-section-header d-flex justify-content-end">
				<div className="portfolios-controls">
					{/* <button className="btn btn-outline-secondary me-2">
						<i className="bi bi-funnel me-2" />
						Filters
					</button> */}
					<div className="btn-group me-2" role="group">
						<button
							type="button"
							className={`btn ${
								viewMode === 'grid' ? 'btn-dark' : 'btn-outline-secondary'
							}`}
							onClick={() => setViewMode('grid')}
							title="Grid View"
						>
							<i className="bi bi-grid-3x3-gap" />
						</button>
						<button
							type="button"
							className={`btn ${
								viewMode === 'table' ? 'btn-dark' : 'btn-outline-secondary'
							}`}
							onClick={() => setViewMode('table')}
							title="Table View"
						>
							<i className="bi bi-list" />
						</button>
					</div>
				</div>
			</div>
			<div className="property-section-body">
				{portfolios?.length === 0 ? (
					<div className="property-section-body empty-state">
						<i className="bi bi-folder-open" />
						<p>This property is not attached to any portfolios.</p>
					</div>
				) : (
					<>
						{viewMode === 'grid' ? (
							<PortfolioGrid
								portfolios={portfolios}
								onView={onPortfolioView}
								onEdit={onPortfolioEdit}
								onDelete={onPortfolioDelete}
							/>
						) : (
							<PortfolioTable
								portfolios={portfolios}
								onView={onPortfolioView}
								onEdit={onPortfolioEdit}
								onDelete={onPortfolioDelete}
							/>
						)}
					</>
				)}
			</div>
		</div>
	);
};

export default AttachedPortfoliosSection;
